<template>
    <app-layout class="insurance-plans">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>
            </common-content-spacer>
            <common-page-header :heading="pageTitle" size="minor"></common-page-header>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <ancillary-service-selection
                        :ancillaryServices="ancillaryServices"
                        :showHeader="false"
                        @proceed-to-patient-form="proceedToPatientForm"
                    ></ancillary-service-selection>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'
    import AncillaryServiceSelection from 'components/page-elements/ancillary-service-selection/AncillaryServiceSelection'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            AppLayout,
            AncillaryServiceSelection,
        },

        data() {
            return {
                ancillaryServices: [],
                isLoading: false,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.practice.profile.titles.practice_profile', { practiceName: this.$auth.getPractice().name })
            },

            prefillValues() {
                return this.$auth.getPractice().facilityServiceTypes
            },

            pageSubTitle() {
                return this.$t('pages.practice.insurance.titles.insurance_plans_accepted')
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice'),
                        route: { name: 'practice.members' },
                    },
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice_profile'),
                        route: { name: 'practice.profile-ancillary' },
                    },
                    {
                        label: this.$t('pages.practice.profile.breadcrumbs.practice_services'),
                    },
                ]
            },
        },

        methods: {
            saveChanges(value) {
                FacilityServicesAPI.updateFacilaryServiceTypes(this.$auth.getPractice().id, {
                    facilityServiceIds: value.map((item) => item.id),
                }).then(() => {
                    this.updatePracticeAndRedirect()
                })
            },

            updatePracticeAndRedirect() {
                this.$auth.updateFacilityServicesByLocation().then(() => {
                    this.$auth.forceUpdatePractice()
                    const services = this.$auth.getFacilityServicesByLocation()
                    const locationsLength = this.$auth.getPractice().locations.length + 1
                    const newServiceAdded = services.some((service) => {
                        return service.practiceTypesSubgroups.length < locationsLength
                    })

                    if (!newServiceAdded) {
                        this.$router.push({ name: 'practice.profile-ancillary' })
                        return
                    }

                    const firstServiceWithoutTests = services.find(
                        (service) => service.practiceTypesSubgroups.length !== locationsLength,
                    )
                    this.$router.push(`/practice/service/${firstServiceWithoutTests.facilityServiceTypeId}/tests?advance=true`)
                })
            },

            loadAncillary() {
                FacilityServicesAPI.getFacilityServiceGroups().then((response) => {
                    this.ancillaryServices = response
                })
            },

            proceedToPatientForm(value) {
                this.$router.push({
                    name: `referrals.new.make`,
                    query: {
                        ...this.$route.query,
                        referralTests: value,
                    },
                })
            },
        },

        mounted() {
            this.loadAncillary()
        },
    }
</script>

<style lang="scss" scoped>
    .insurance-plans {
        &__back-button {
            .icon {
                margin-top: 10px;
            }
        }
    }
</style>
